module.exports = __webpack_public_path__ + "img/document-sign.13a84da7.svg";